export default __webpack_public_path__ + "static/media/sponsor_10.41ec4b71.png";